const apiUrl = process.env.REACT_APP_API_URL;
const base = `${apiUrl}:8061`;

function authHeaders(json = true): Record<string, string> {
    const h: Record<string, string> = {
        'Authorization': `Bearer ${localStorage.getItem('authToken') || localStorage.getItem('token') || ''}`
    };
    if (json) h['Content-Type'] = 'application/json';
    return h;
}

// ===== Botines (loot) admin =====

export async function GetBotines() {
    try {
        const res = await fetch(`${base}/admin/game/botines`, { headers: authHeaders(false) });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
    } catch (e) {
        console.error('Error al obtener botines:', e);
        return [];
    }
}

/**
 * Crea (id=0) o actualiza un botín.
 * body: { id?, identifier, nom, descr?, active }
 * Devuelve { status, id } o null.
 */
export async function PostBotin(body: any) {
    try {
        const res = await fetch(`${base}/admin/game/botines`, {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
    } catch (e) {
        console.error('Error al guardar botín:', e);
        return null;
    }
}

export async function DeleteBotin(id: number | string) {
    try {
        const res = await fetch(`${base}/admin/game/botines/${id}`, {
            method: 'DELETE',
            headers: authHeaders(false)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al eliminar botín:', e);
        return false;
    }
}

// ===== Recompensas de un botín (acepta id numérico o identifier) =====

export async function GetBotinRecompenses(idBotin: number | string) {
    try {
        const res = await fetch(`${base}/jutge/botin/${idBotin}/recompenses`, { headers: authHeaders(false) });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
    } catch (e) {
        console.error('Error al obtener recompensas del botín:', e);
        return [];
    }
}

/**
 * Añade una recompensa a un botín.
 * recompensa: { tipo, valor?, id_item?, imagen?, limit_quantity? }
 */
export async function PostBotinRecompensa(idBotin: number | string, recompensa: any) {
    try {
        const res = await fetch(`${base}/jutge/botin/${idBotin}/recompenses`, {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify(recompensa)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al añadir recompensa al botín:', e);
        return false;
    }
}

/**
 * Actualiza una recompensa existente de un botín.
 * recompensa: { tipo, valor?, id_item?, imagen?, limit_quantity? }
 */
export async function PutBotinRecompensa(idBotin: number | string, idRecompensa: number | string, recompensa: any) {
    try {
        const res = await fetch(`${base}/jutge/botin/${idBotin}/recompenses/${idRecompensa}`, {
            method: 'PUT',
            headers: authHeaders(),
            body: JSON.stringify(recompensa)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al actualizar recompensa del botín:', e);
        return false;
    }
}

export async function DeleteBotinRecompensa(idBotin: number | string, idRecompensa: number | string) {
    try {
        const res = await fetch(`${base}/jutge/botin/${idBotin}/recompenses/${idRecompensa}`, {
            method: 'DELETE',
            headers: authHeaders(false)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al eliminar recompensa del botín:', e);
        return false;
    }
}

// ===== Historial de reclamos (qué usuario ha reclamado cada recompensa, y en qué aula) =====

export async function GetBotinUsuarisRecompenses(idBotin: number | string) {
    try {
        const res = await fetch(`${base}/jutge/botin/${idBotin}/usuaris`, { headers: authHeaders(false) });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
    } catch (e) {
        console.error('Error al obtener el historial del botín:', e);
        return [];
    }
}

export async function DeleteBotinRecompensaUsuari(idBotin: number | string, idReclamo: number | string) {
    try {
        const res = await fetch(`${base}/jutge/botin/${idBotin}/usuaris/${idReclamo}`, {
            method: 'DELETE',
            headers: authHeaders(false)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al eliminar el reclamo del usuario:', e);
        return false;
    }
}

